import React from 'react';
import error from '../../assets/images/404error.svg';
import { SvgIconProps } from '@mui/material';

export const Af404ErrorIcon: React.FC<SvgIconProps> = () => {
  return <img src={error} />;
};
